import { render, staticRenderFns } from "./FringeBenefitsDetails.vue?vue&type=template&id=bd8a914c&scoped=true"
import script from "./FringeBenefitsDetails.vue?vue&type=script&lang=js"
export * from "./FringeBenefitsDetails.vue?vue&type=script&lang=js"
import style0 from "./FringeBenefitsDetails.vue?vue&type=style&index=0&id=bd8a914c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8a914c",
  null
  
)

export default component.exports